export function withMapArgs(mapper) {
  return (baseFunction) => {
    const mapArgs = (...args) => baseFunction(...mapper(...args));

    return mapArgs;
  };
}
